import { IOnInit, ITimeoutService } from "angular";
import { Permission, Role } from "../../../model/authorityGroup";
import { chunk } from "lodash";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../records/server/serverUtility";

export class RoleDetailPermissionsComponentController implements IOnInit {
  static $inject = ["$timeout", ServerUtilityName];

  // bindings
  private readonly permissions!: Permission[];
  private readonly role!: Role;
  // end bindings

  private chunkedPermissions: Permission[][] = [];

  constructor(
    private readonly $timeout: ITimeoutService,
    private readonly serverUtility: ServerUtility
  ) {}

  $onInit(): void {
    this.chunkedPermissions = chunk(this.permissions, 4);
    this.$timeout(0).then(() => {
      this.permissions.forEach((p) => {
        p.RolePermission = !!this.role.RolePermissions?.find(
          (rp) => rp.PermissionId === p.Id
        );
      });
    });
  }

  rolePermissionChanged(permission: Permission, rolePermission: boolean) {
    this.serverUtility.sendApiRequest<void>({
      method: rolePermission ? "POST" : "DELETE",
      url: `/api/role/${this.role.Id}/permissions`,
      data: {
        PermissionId: permission.Id,
      },
    });
  }
}
